import { Alert } from 'antd';
import { useEffect, useRef, useState } from 'react';

export const useTour = flag => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [allowNextStep, setAllowNextStep] = useState(false);

  const registerServerRef = useRef(null);
  const serversTableRef = useRef(null);
  const statusColumnRef = useRef(null);
  const downloadKeyRef = useRef(null);

  useEffect(() => {
    setAllowNextStep(flag);
  }, [flag]);

  const steps = [
    {
      title: 'Страница Локальные сервера',
      description:
        'Добро пожаловать в раздел «Локальные сервера» — здесь вы регистрируете и управляете локальными серверами для работы в закрытых сетях. Быстрая выдача лицензий и удобный контроль доступов.',
      target: null,
    },
    {
      title: 'Зарегистрировать локальный сервер',
      description: 'Нажмите для регистрации нового локального сервера.',
      target: () => registerServerRef.current,
    },
    {
      title: 'Окно регистрации сервера',
      description: (
        <>
          <p>Заполните необходимые поля и нажмите ОК для отправки запроса на регистрацию.</p>
          {!allowNextStep && (
            <Alert message={'Чтобы продолжить тур зарегистрируйте заявку!'} style={{ marginTop: '10px' }} />
          )}
        </>
      ),
      target: () => registerServerRef.current,
    },
    {
      title: 'Таблица локальных серверов',
      description:
        'В таблице отображаются все зарегистрированные локальные сервера с данными о владельцах и статусом регистрации.',
      target: null,
    },
    {
      title: 'Колонка «Статус»',
      description: (
        <>
          <p>Статусы:</p>
          <p>• На подтверждении — запрос на регистрацию отправлен и ожидает одобрения администратора.</p>
          <p>• Подтверждён — сервер успешно зарегистрирован, лицензионный ключ доступен для скачивания.</p>
        </>
      ),
      target: () => statusColumnRef.current,
    },
    {
      title: 'Скачать ключ лицензии',
      description:
        'Нажмите, чтобы скачать сгенерированный лицензионный ключ для локального сервера. Доступ к скачиванию открыт только для отправителя запроса — ключи других пользователей защищены и недоступны для скачивания.',
      target: () => downloadKeyRef.current,
    },
  ];

  const startTour = () => {
    setCurrentStep(0);
    setIsTourOpen(true);
  };

  const handleTourChange = nextStep => {
    if (!allowNextStep && currentStep === 2) {
      return;
    }

    setCurrentStep(nextStep);
  };

  const handleClose = () => {
    setIsTourOpen(false);
  };

  return {
    registerServerRef,
    serversTableRef,
    statusColumnRef,
    downloadKeyRef,
    steps,
    startTour,
    handleTourChange,
    handleClose,
    isTourOpen,
    currentStep,
  };
};
